import { EvaluationContext, QuestionContext } from '../../../../Helpers/QuestionContextHelper';
import { QuestionItem } from '../../../../Models/Questions/QuestionDto';
import { TypeDeLocalName, UnitType } from '../../../../Plugins/FloorPlan/Models/IRoom';

export const useHabitationContextController = (habitationQuestions: Array<QuestionItem> = []) => {

    const getContextWithEvaluations = (habitationQuestions: QuestionItem[]): QuestionContext => {
        const lastHabitationQuestionContext = habitationQuestions[habitationQuestions.length - 1]?.context;
        return lastHabitationQuestionContext ?? {};
    };

    const getUnitType = (questions?: QuestionItem[]) => {
        const context = getContextWithEvaluations(questions || habitationQuestions);
        const evaluations: EvaluationContext = context?.evaluations ?? {};
        const unitType: UnitType = evaluations[TypeDeLocalName];
        return unitType;
    };
    return { getContextWithEvaluations, getUnitType };
};
